export default "__VITE_ASSET__BM0pwSqF__"